module.exports = __webpack_public_path__ + "img/whats-new-53-hero_16x9_jp_poster.10f7d7b.jpg";